export * from "./effect.webgl.functions.pure";
